// extracted by mini-css-extract-plugin
export default {"costCellRendererComponent":"CostCellRendererComponent_costCellRendererComponent__bXglh"};